export const skipSession = 'x-skip-session';
